import React from 'react';
import NewPassword from 'components/AuthNew/NewPasswordPage';;

const NewPasswordPage = props => {
  return <NewPassword {...props} />;
};

export default NewPasswordPage;